var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'usertype-new',
  created () {
    this.$store.dispatch('USERTYPE_ALL_GET', {})
  },
  data () {
    return {
      canValidate: true,
      contentCount: 0,
      savingFlag: false,
      business_type: {
        user_type_id: null,
        business_type_content: null
      }
    }
  },
  computed: {
    usertypes () {
      return this.$store.getters.usertypesAll
    },
    validation: function () {
      var v = {
        user_type_id: !!this.business_type.user_type_id,
        business_type_content: !!this.business_type.business_type_content,
        not_input: !!this.business_type.user_type_id && !!this.business_type.business_type_content
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        this.$store.dispatch('BUSINESS_TYPE_CREATE',
          { data: this.business_type, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/business_types', query: { type: this.$router.currentRoute.query.type}})
    },
    half: function () {
      this.business_type.business_type_content = utils.emHalf(this.business_type.business_type_content)
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/business_types')
    },
    contentCounter: function() {
      this.half()
      this.contentCount = this.business_type.business_type_content.length
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/businesstype-new.js